<template>
  <div
    class="input-text__container"
    :class="[{'input-text__state-disabled': disabled}]">
    <div
      :class="[
        { 'disabled': disabled },
        'input-text__input-container',
        'tw-gap-2',
        'body--body-01',
        'tw-border-core-neutral-cold-80 tw-bg-core-neutral-cold-100',
        'focus-within:tw-bg-core-primary-99 focus-within:tw-border-core-primary-50'
      ]">
      <input
        :value="searchText"
        class="search-box-input tw-grow focus-within:tw-bg-core-primary-99 focus:tw-outline-none"
        :data-test="dataTest"
        :placeholder="actualPlaceholder"
        :disabled="disabled"
        @input="(e) => emit('input', e.target.value)">
      <SVGIcon
        v-if="!searchText"
        :colorClass="disabled ? 'tw-fill-core-neutral-cold-50' : 'tw-fill-primary-10'"
        iconName="SearchFill0"
        :remSize="1.25" />
      <button
        v-if="searchText"
        data-test="search-box-close-button"
        @click.stop="cleanSearchHandler">
        <SVGIcon
          iconName="Close"
          colorClass="tw-fill-core-neutral-cold-20"
          :remSize="1" />
      </button>
    </div>
    <InputHelperText
      :error="error"
      :supportingText="supportingText" />
  </div>
</template>

<script setup lang="ts">
import i18n from 'frontcore/i18n'
import InputHelperText from "frontcore/views/select/InputHelperText.vue"
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import { ref, watch } from 'vue'

interface Props {
  dataTest?: string
  error?: string
  placeholder?: string
  supportingText?: string
  value: string
  disabled?: boolean
}

const { t } = i18n.global

const props = withDefaults(defineProps<Props>(), {
  dataTest: 'search-box-input',
  placeholder: '',
  disabled: false,
})

const actualPlaceholder = props.placeholder !== '' ? props.placeholder : `${t('common.messages.search')}...`
type Emits = (e: 'input', value: string | undefined) => void
const emit = defineEmits<Emits>()

const searchText = ref(props.value)

const cleanSearchHandler = () => {
  emit('input', '')
}

watch(
  () => props.value,
  (newVal) => searchText.value = newVal
)

</script>
